/** Données simulées pour prévisualiser l'admin Care (mode démo). */

const now = Date.now();
const iso = (offsetMs) => new Date(now + offsetMs).toISOString();
const daysAgo = (d) => iso(-d * 86400000);

const DEMO_IDS = {
  alert1: 'a1000001-0001-4001-8001-000000000001',
  alert2: 'a1000002-0002-4002-8002-000000000002',
  alert3: 'a1000003-0003-4003-8003-000000000003',
  alert4: 'a1000004-0004-4004-8004-000000000004',
  alert5: 'a1000005-0005-4005-8005-000000000005',
  sub1: 'b2000001-0001-4001-8001-000000000001',
  sub2: 'b2000002-0002-4002-8002-000000000002',
  sub3: 'b2000003-0003-4003-8003-000000000003',
  iv1: 'c3000001-0001-4001-8001-000000000001',
  iv2: 'c3000002-0002-4002-8002-000000000002',
  partner1: 'd4000001-0001-4001-8001-000000000001',
  partner2: 'd4000002-0002-4002-8002-000000000002',
  guardian1: 'e5000001-0001-4001-8001-000000000001',
  guardian2: 'e5000002-0002-4002-8002-000000000002',
  reco1: 'f6000001-0001-4001-8001-000000000001',
};

const DEMO_ALERTS = [
  { id: DEMO_IDS.alert1, beneficiary_id: DEMO_IDS.sub1, beneficiary_name: 'Christopher Ramboz', alert_type: 'sos', type: 'sos', severity: 'critical', status: 'active', message: 'SOS bracelet · bouton pressé', teleassistance_status: 'in_progress', source: 'teleassistance', created_at: iso(-12 * 60000), resolved_at: null },
  { id: DEMO_IDS.alert2, beneficiary_id: DEMO_IDS.sub2, beneficiary_name: 'Marie Dupont', alert_type: 'fall_detected', type: 'fall_detected', severity: 'high', status: 'active', message: 'Chute détectée · accéléromètre', teleassistance_status: 'pending', source: 'teleassistance', created_at: iso(-45 * 60000), resolved_at: null },
  { id: DEMO_IDS.alert3, beneficiary_id: DEMO_IDS.sub3, beneficiary_name: 'Jean Martin', alert_type: 'heart_rate', type: 'heart_rate', severity: 'medium', status: 'acknowledged', message: 'Pouls élevé · 112 bpm', teleassistance_status: 'in_progress', source: 'carewatch', created_at: iso(-3 * 3600000), resolved_at: null },
  { id: DEMO_IDS.alert4, beneficiary_id: DEMO_IDS.sub1, beneficiary_name: 'Christopher Ramboz', alert_type: 'spo2', type: 'spo2', severity: 'medium', status: 'resolved', message: 'SpO2 basse · 89 %', teleassistance_status: 'resolved', source: 'carewatch', created_at: daysAgo(1), resolved_at: iso(-20 * 3600000) },
  { id: DEMO_IDS.alert5, beneficiary_id: DEMO_IDS.sub2, beneficiary_name: 'Marie Dupont', alert_type: 'geofence', type: 'geofence', severity: 'low', status: 'resolved', message: 'Sortie de zone domicile', teleassistance_status: 'resolved', source: 'geofence_server', created_at: daysAgo(2), resolved_at: daysAgo(2) },
  { id: 'a1000006-0006-4006-8006-000000000006', beneficiary_id: DEMO_IDS.sub3, beneficiary_name: 'Jean Martin', alert_type: 'sos_manual', type: 'sos_manual', severity: 'critical', status: 'resolved', message: 'SOS application mobile', teleassistance_status: 'resolved', source: 'teleassistance', created_at: daysAgo(3), resolved_at: daysAgo(3) },
  { id: 'a1000007-0007-4007-8007-000000000007', beneficiary_id: 'b2000004-0004-4004-8004-000000000004', beneficiary_name: 'Hélène Bernard', alert_type: 'threshold', type: 'threshold', severity: 'medium', status: 'resolved', message: 'Tension artérielle hors seuil', teleassistance_status: 'resolved', source: 'carewatch', created_at: daysAgo(4), resolved_at: daysAgo(4) },
  { id: 'a1000008-0008-4008-8008-000000000008', beneficiary_id: 'b2000005-0005-4005-8005-000000000005', beneficiary_name: 'Robert Leroy', alert_type: 'inactivity', type: 'inactivity', severity: 'low', status: 'resolved', message: 'Inactivité prolongée · 4 h', teleassistance_status: 'resolved', source: 'carewatch', created_at: daysAgo(5), resolved_at: daysAgo(5) },
];

function demoDashboard() {
  return {
    kpis: {
      care_subscribers: 48,
      active_alerts: 2,
      alerts_7d: 23,
      interventions_total: 156,
      interventions_active: 3,
      interventions_30d: 18,
      sad_partners: 12,
      affiliated_guardians: 67,
      recommendations_pending: 8,
      recommendations_validated: 34,
      recommendations_30d: 11,
      escalations_active: 1,
      nora_sessions_open: 1,
    },
    alerts_by_day: [0, 1, 2, 3, 4, 5, 6].map((i) => ({
      day: daysAgo(6 - i).slice(0, 10),
      count: [2, 4, 1, 5, 3, 6, 2][i],
    })),
    interventions_by_month: [
      { month: 'Fév 26', count: 12 },
      { month: 'Mar 26', count: 15 },
      { month: 'Avr 26', count: 11 },
      { month: 'Mai 26', count: 18 },
      { month: 'Juin 26', count: 14 },
      { month: 'Juil 26', count: 18 },
    ],
    alert_types_30d: [
      { type: 'sos', count: 8 },
      { type: 'fall_detected', count: 6 },
      { type: 'heart_rate', count: 5 },
      { type: 'spo2', count: 4 },
      { type: 'geofence', count: 3 },
    ],
  };
}

function demoLabAnalytics(days = 30) {
  const byHour = Array.from({ length: 24 }, (_, h) => ({
    hour: h,
    label: `${String(h).padStart(2, '0')}h`,
    count: h >= 7 && h <= 22 ? Math.round(3 + 8 * Math.sin((h - 8) / 4) + (h === 14 ? 5 : 0)) : Math.max(0, Math.round(Math.random() * 2)),
  }));
  const byWeekday = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'].map((label, wd) => ({
    weekday: wd,
    label,
    count: [4, 12, 10, 11, 14, 9, 6][wd],
  }));
  const trend = Array.from({ length: Math.min(days, 30) }, (_, i) => ({
    date: daysAgo(29 - i).slice(0, 10),
    label: `${String(new Date(daysAgo(29 - i)).getDate()).padStart(2, '0')}/${String(new Date(daysAgo(29 - i)).getMonth() + 1).padStart(2, '0')}`,
    count: 2 + Math.round(Math.random() * 6),
  }));

  return {
    period: { mode: 'days', days, label: `${days} derniers jours` },
    summary: {
      alerts_total: 127,
      beneficiaries_with_alerts: 38,
      avg_age_years: 76.4,
      avg_alert_duration_min: 18.6,
      avg_nora_session_min: 4.2,
      avg_call_duration_sec: 87,
      health_anomaly_rate_pct: 34.6,
      sos_rate_pct: 22.8,
      fall_rate_pct: 14.2,
      intervention_rate_pct: 41.7,
      resolution_rate_pct: 88.2,
      nora_escalation_rate_pct: 28.5,
      avg_trigger_hour: 14.3,
      avg_trigger_label: '14h18',
    },
    by_type: [
      { type: 'sos', count: 29 },
      { type: 'fall_detected', count: 18 },
      { type: 'heart_rate', count: 16 },
      { type: 'spo2', count: 12 },
      { type: 'threshold', count: 11 },
      { type: 'geofence', count: 9 },
      { type: 'sos_manual', count: 8 },
      { type: 'temperature', count: 6 },
    ],
    by_category: [
      { category: 'sos', label: 'SOS', count: 37 },
      { category: 'health', label: 'Santé · seuils', count: 44 },
      { category: 'fall', label: 'Chute', count: 18 },
      { category: 'geofence', label: 'Géolocalisation', count: 9 },
      { category: 'other', label: 'Autres', count: 19 },
    ],
    by_hour: byHour,
    by_weekday: byWeekday,
    by_age_bucket: [
      { bucket: '75-84 ans', count: 48 },
      { bucket: '65-74 ans', count: 35 },
      { bucket: '85 ans et +', count: 28 },
      { bucket: '< 65 ans', count: 9 },
      { bucket: 'inconnu', count: 7 },
    ],
    by_severity: [
      { severity: 'medium', count: 52 },
      { severity: 'high', count: 38 },
      { severity: 'critical', count: 24 },
      { severity: 'low', count: 13 },
    ],
    by_device: [
      { device: 'bracelet', count: 89 },
      { device: 'mobile_app', count: 28 },
      { device: 'inconnu', count: 10 },
    ],
    alerts_by_day: trend,
    nora: {
      sessions: 42,
      patient_ok: 24,
      need_help: 9,
      escalated: 12,
      patient_ok_rate_pct: 57.1,
      need_help_rate_pct: 21.4,
      by_intent: [
        { intent: 'ok', count: 24 },
        { intent: 'need_help', count: 9 },
        { intent: 'no_response', count: 6 },
      ],
    },
    interventions: {
      total: 53,
      completed: 47,
      completion_rate_pct: 88.7,
      avg_duration_min: 42.3,
      avg_time_to_start_min: 16.8,
    },
    health_signals: {
      threshold_alerts: 44,
      by_metric: [
        { metric: 'heart_rate', count: 16 },
        { metric: 'spo2', count: 12 },
        { metric: 'blood_pressure', count: 9 },
        { metric: 'temperature', count: 4 },
        { metric: 'pulse', count: 3 },
      ],
    },
    top_beneficiaries: [
      { name: 'Christopher Ramboz', age: 58, alert_count: 12 },
      { name: 'Marie Dupont', age: 81, alert_count: 9 },
      { name: 'Jean Martin', age: 74, alert_count: 8 },
      { name: 'Hélène Bernard', age: 86, alert_count: 7 },
      { name: 'Robert Leroy', age: 79, alert_count: 6 },
    ],
    rd_insights: [
      {
        key: 'predictive_risk',
        title: 'Score prédictif de risque',
        description: 'Score proxy : alertes + pondération santé (×2) et SOS (×3).',
        status: 'prototype',
        kpis: [{ label: 'Profils analysés', value: '5' }, { label: 'Score max', value: '28' }, { label: 'Alertes période', value: '127' }],
        chart: [
          { label: 'Christopher R.', value: 28, meta: { alerts: 12, health: 4, sos: 4, age: 58 } },
          { label: 'Marie Dupont', value: 22, meta: { alerts: 9, health: 3, sos: 3, age: 81 } },
          { label: 'Jean Martin', value: 18, meta: { alerts: 8, health: 2, sos: 2, age: 74 } },
        ],
        insight: 'Christopher Ramboz présente le score le plus élevé (28) sur la période.',
      },
      {
        key: 'false_positive',
        title: 'Taux de faux positifs Aria',
        description: 'Écarts entre intention téléphonique et gravité de l\'alerte d\'origine.',
        status: 'collecte',
        kpis: [{ label: 'Sessions Aria', value: '42' }, { label: 'Confirmations OK', value: '57.1 %' }, { label: 'OK sur alerte critique', value: '12.5 %' }],
        chart: [{ label: 'Tout va bien', value: 24 }, { label: 'Besoin d\'aide', value: 9 }, { label: 'Autres', value: 9 }],
        insight: '12.5 % des sessions Aria se closent par « tout va bien » sur une alerte critique ou élevée.',
      },
      {
        key: 'circadian',
        title: 'Profils circadiens',
        description: 'Répartition jour / nuit et pic matinal pour ajuster seuils.',
        status: 'prototype',
        kpis: [{ label: 'Alertes de nuit', value: '18.1 %' }, { label: 'Alertes de jour', value: '81.9 %' }, { label: 'Pic matinal (6h-10h)', value: '22' }],
        chart: [{ label: 'Nuit (22h-6h)', value: 23 }, { label: 'Jour', value: 104 }, { label: 'Matin (6h-10h)', value: 22 }],
        insight: 'Profil plutôt diurne sur la période observée.',
      },
      {
        key: 'intervention_sla',
        title: 'SLA intervention SAD',
        description: 'Délai alerte → prise en charge et durée terrain, par agence.',
        status: 'prototype',
        kpis: [{ label: 'Interventions', value: '53' }, { label: 'Prise en charge < 15 min', value: '62.3 %' }, { label: 'Agences actives', value: '2' }],
        chart: [{ label: 'Lyon Centre', value: 14.2 }, { label: 'Villeurbanne', value: 18.6 }],
        rows: [
          { agency: 'Agence Lyon Centre', interventions: 32, sla_15m_pct: 68.8, avg_start_min: 14.2, avg_duration_min: 38.5 },
          { agency: 'Agence Villeurbanne', interventions: 21, sla_15m_pct: 52.4, avg_start_min: 18.6, avg_duration_min: 45.1 },
        ],
        insight: '62.3 % des interventions démarrent en moins de 15 minutes après l\'alerte.',
      },
      {
        key: 'comorbidity',
        title: 'Alertes × comorbidités',
        description: 'Croisement pathologies déclarées et volume d\'alertes.',
        status: 'prototype',
        kpis: [{ label: 'Pathologies corrélées', value: '4' }, { label: 'Alertes liées', value: '38' }],
        chart: [{ label: 'Hypertension', value: 14 }, { label: 'Diabète type 2', value: 11 }, { label: 'Insuffisance cardiaque', value: 8 }],
        rows: [
          { pathology: 'Hypertension', alerts: 14, beneficiaries: 6 },
          { pathology: 'Diabète type 2', alerts: 11, beneficiaries: 4 },
          { pathology: 'Insuffisance cardiaque', alerts: 8, beneficiaries: 3 },
        ],
        insight: '« Hypertension » est la comorbidité la plus présente dans les alertes (14).',
      },
      {
        key: 'device_reliability',
        title: 'Fiabilité capteurs',
        description: 'Anomalies par modèle de bracelet et état batterie.',
        status: 'collecte',
        kpis: [{ label: 'Modèles distincts', value: '3' }, { label: 'Batterie moyenne', value: '72 %' }, { label: 'Appareils < 20 %', value: '2' }],
        chart: [{ label: 'elder', value: 89 }, { label: 'v6_4g', value: 28 }, { label: 'vita', value: 10 }],
        rows: [
          { model: 'elder', alerts: 89, battery_alerts: 3 },
          { model: 'v6_4g', alerts: 28, battery_alerts: 1 },
          { model: 'vita', alerts: 10, battery_alerts: 0 },
        ],
        insight: 'Le modèle « elder » concentre le plus d\'alertes (89).',
      },
    ],
  };
}

function demoAnalytics(days = 30) {
  return {
    period: { days, label: `${days} derniers jours` },
    alerts: {
      total: 127,
      active: 2,
      resolved: 112,
      carewatch: 68,
      teleassistance: 59,
      mttr_minutes: 18.6,
      resolution_rate_pct: 88.2,
    },
    by_type: demoLabAnalytics(days).by_type.slice(0, 8),
    by_source: [
      { source: 'carewatch', count: 68 },
      { source: 'teleassistance', count: 59 },
      { source: 'geofence_server', count: 12 },
    ],
    nora: { sessions: 42, resolved_auto: 24, with_operator: 3 },
    interventions: { total: 53, completed: 47 },
  };
}

function demoSubscribers() {
  return {
    items: [
      { id: DEMO_IDS.sub1, user_id: DEMO_IDS.sub1, name: 'Christopher Ramboz', phone: '+33651245918', city: 'Lyon', plan: 'Care Plus', status: 'active', teleassistance: true, created_at: daysAgo(120) },
      { id: DEMO_IDS.sub2, user_id: DEMO_IDS.sub2, name: 'Marie Dupont', phone: '+33612345678', city: 'Villeurbanne', plan: 'Care Essentiel', status: 'active', teleassistance: true, created_at: daysAgo(90) },
      { id: DEMO_IDS.sub3, user_id: DEMO_IDS.sub3, name: 'Jean Martin', phone: '+33698765432', city: 'Caluire', plan: 'Care Plus', status: 'active', teleassistance: true, created_at: daysAgo(60) },
      { id: 'b2000004-0004-4004-8004-000000000004', user_id: 'b2000004-0004-4004-8004-000000000004', name: 'Hélène Bernard', phone: '+33687654321', city: 'Bron', plan: 'Care Essentiel', status: 'active', teleassistance: true, created_at: daysAgo(45) },
      { id: 'b2000005-0005-4005-8005-000000000005', user_id: 'b2000005-0005-4005-8005-000000000005', name: 'Robert Leroy', phone: '+33676543210', city: 'Décines', plan: 'Care Plus', status: 'active', teleassistance: true, created_at: daysAgo(30) },
    ],
  };
}

function demoInterventions() {
  return {
    items: [
      { id: DEMO_IDS.iv1, beneficiary_name: 'Christopher Ramboz', intervenant_name: 'Sophie Mercier', status: 'in_progress', created_at: iso(-2 * 3600000), completed_at: null },
      { id: DEMO_IDS.iv2, beneficiary_name: 'Marie Dupont', intervenant_name: 'Lucas Petit', status: 'en_route', created_at: iso(-90 * 60000), completed_at: null },
      { id: 'c3000003-0003-4003-8003-000000000003', beneficiary_name: 'Jean Martin', intervenant_name: 'Claire Dubois', status: 'completed', created_at: daysAgo(1), completed_at: daysAgo(1) },
      { id: 'c3000004-0004-4004-8004-000000000004', beneficiary_name: 'Hélène Bernard', intervenant_name: 'Marc Renard', status: 'done', created_at: daysAgo(2), completed_at: daysAgo(2) },
    ],
  };
}

function demoPartners() {
  return {
    items: [
      { id: DEMO_IDS.partner1, name: 'SAD Lyon Métropole', city: 'Lyon', status: 'active', guardians_count: 24, agencies_count: 3 },
      { id: DEMO_IDS.partner2, name: 'Aide à Domicile Rhône', city: 'Villeurbanne', status: 'active', guardians_count: 18, agencies_count: 2 },
      { id: 'd4000003-0003-4003-8003-000000000003', name: 'Pharmacie HAD Gerland', city: 'Lyon', status: 'active', guardians_count: 8, agencies_count: 1 },
    ],
  };
}

function demoGuardians() {
  return {
    items: [
      { id: DEMO_IDS.guardian1, name: 'Paul Ramboz', phone: '+33611223344', beneficiaries_count: 2, structure_name: 'SAD Lyon Métropole' },
      { id: DEMO_IDS.guardian2, name: 'Isabelle Dupont', phone: '+33655667788', beneficiaries_count: 1, structure_name: 'Aide à Domicile Rhône' },
      { id: 'e5000003-0003-4003-8003-000000000003', name: 'François Martin', phone: '+33699887766', beneficiaries_count: 1, structure_name: 'SAD Lyon Métropole' },
    ],
  };
}

function demoRecommendations() {
  return {
    items: [
      { id: DEMO_IDS.reco1, status: 'pending', prescriber_name: 'Dr. Moreau', structure_name: 'Pharmacie HAD Gerland', beneficiary_name: 'Anne Girard', created_at: daysAgo(2), commission_estimated_ht: 45 },
      { id: 'f6000002-0002-4002-8002-000000000002', status: 'validated', prescriber_name: 'Dr. Lambert', structure_name: 'SAD Lyon Métropole', beneficiary_name: 'Pierre Faure', created_at: daysAgo(8), commission_paid_ht: 45 },
    ],
  };
}

function demoRecoSummary() {
  return {
    period: { label: '30 derniers jours' },
    counts: { pending: 8, validated: 34, total_in_period: 42 },
    commissions: { earned_ht: 1240, accrued_ht: 380, estimated_pipeline_ht: 360 },
  };
}

function demoFinance() {
  return {
    period: { label: '30 derniers jours' },
    current_month_label: 'Juillet 2026',
    revenue: { collected_ht: 4820, mrr_ht: 3840, arr_ht: 46080, payments_count: 52, active_subscribers: 48 },
    revenue_current_month: { collected_ht: 2180 },
    commissions: {
      upfront_paid_ht: 680,
      monthly_paid_ht: 420,
      upfront_to_pay_ht: 180,
      monthly_to_pay_ht: 95,
      total_to_pay_ht: 275,
      upfront_to_pay_count: 4,
      monthly_to_pay_count: 6,
    },
    commissions_current_month: {
      upfront_paid_ht: 225,
      monthly_paid_ht: 140,
      upfront_to_pay_ht: 90,
      monthly_to_pay_ht: 45,
    },
    monthly_series: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((m) => ({
      month: new Date(2025, 7 + m, 1).toISOString(),
      revenue_ht: 2800 + m * 180 + Math.round(Math.random() * 400),
    })),
    by_agency: [
      { name: 'Agence Lyon Centre', city: 'Lyon', commissions_paid_ht: 420, commissions_to_pay_ht: 85 },
      { name: 'Agence Villeurbanne', city: 'Villeurbanne', commissions_paid_ht: 280, commissions_to_pay_ht: 60 },
    ],
    by_structure: [
      { name: 'SAD Lyon Métropole', city: 'Lyon', commissions_paid_ht: 520, commissions_to_pay_ht: 120, prescribers_count: 6 },
      { name: 'Aide à Domicile Rhône', city: 'Villeurbanne', commissions_paid_ht: 340, commissions_to_pay_ht: 75, prescribers_count: 4 },
    ],
    commission_lines: [
      { created_at: daysAgo(1), structure_name: 'SAD Lyon Métropole', agency_name: 'Lyon Centre', prescriber_name: 'Dr. Moreau', commission_type: 'upfront', amount_ht: 45, status: 'paid' },
      { created_at: daysAgo(3), structure_name: 'Aide à Domicile Rhône', agency_name: 'Villeurbanne', prescriber_name: 'Dr. Lambert', commission_type: 'monthly', amount_ht: 12, status: 'pending' },
    ],
  };
}

function demoAlertDetail(alertId) {
  const alert = DEMO_ALERTS.find((a) => a.id === alertId) || DEMO_ALERTS[0];
  return {
    alert: {
      ...alert,
      device_type: 'bracelet',
      device_model: 'elder',
      beneficiary_phone: '+33651245918',
      beneficiary_age: 58,
    },
    tracking: [
      { action: 'created', notes: 'Alerte créée', created_at: alert.created_at },
      { action: 'nora_started', notes: 'Levée de doute Aria démarrée', created_at: iso(-10 * 60000) },
      { action: 'calling_patient', notes: 'Appel bénéficiaire en cours', created_at: iso(-8 * 60000) },
    ],
    nora: {
      session_id: 'n1000001-0001-4001-8001-000000000001',
      state: 'calling_patient',
      outcome: null,
      started_at: iso(-10 * 60000),
      call_attempts: [
        { id: 'ca100001-0001-4001-8001-000000000001', phase: 'patient', target_name: alert.beneficiary_name, status: 'in_progress', intent: null, duration_sec: null, recording_url: null, transcript: [] },
      ],
      call_report: null,
    },
    interventions: [],
    threshold: alert.alert_type === 'heart_rate' ? { metric_id: 'heart_rate', metric_value: 112, threshold_max: 100, breach_side: 'high' } : null,
  };
}

function parseDays(path) {
  const m = path.match(/days=(\d+)/);
  return m ? parseInt(m[1], 10) : 30;
}

export function resolveCareDemo(path, options = {}) {
  const method = (options.method || 'GET').toUpperCase();
  const clean = path.split('?')[0];

  if (method !== 'GET') {
    const err = new Error('Mode démo · action refusée');
    err.status = 403;
    throw err;
  }

  if (clean === '/teleassistance/ops/dashboard') return demoDashboard();
  if (clean === '/teleassistance/ops/alerts') return { items: DEMO_ALERTS };
  if (clean.startsWith('/teleassistance/ops/lab-analytics')) return demoLabAnalytics(parseDays(path));
  if (clean.startsWith('/teleassistance/ops/analytics')) return demoAnalytics(parseDays(path));
  if (clean === '/teleassistance/subscribers') return demoSubscribers();
  if (clean === '/teleassistance/ops/interventions') return demoInterventions();
  if (clean === '/teleassistance/ops/partners') return demoPartners();
  if (clean === '/teleassistance/ops/guardians') return demoGuardians();
  if (clean.startsWith('/teleassistance/ops/recommendations/summary')) return demoRecoSummary();
  if (clean.startsWith('/teleassistance/ops/recommendations')) return demoRecommendations();
  if (clean === '/teleassistance/ops/finance/filters') return { structures: [{ id: DEMO_IDS.partner1, name: 'SAD Lyon Métropole' }], agencies: [{ id: 'ag1', name: 'Lyon Centre', structure_id: DEMO_IDS.partner1 }] };
  if (clean.startsWith('/teleassistance/ops/finance')) return demoFinance();
  if (clean.startsWith('/teleassistance/ops/search')) {
    const q = decodeURIComponent(path.match(/q=([^&]+)/)?.[1] || '').toLowerCase();
    const match = (s) => (s.name || s.beneficiary_name || '').toLowerCase().includes(q);
    return {
      subscribers: demoSubscribers().items.filter(match),
      alerts: DEMO_ALERTS.filter(match),
      partners: demoPartners().items.filter(match),
      guardians: demoGuardians().items.filter(match),
    };
  }
  if (clean.match(/^\/alerts\/[^/]+\/detail$/)) {
    const id = clean.split('/')[2];
    return demoAlertDetail(id);
  }
  if (clean.match(/^\/teleassistance\/ops\/partners\/[^/]+$/)) {
    const p = demoPartners().items[0];
    return { structure: { ...p, email: 'contact@sad-lyon.demo', phone: '+33478000001' }, stats: { subscribers: 18, guardians: 24, interventions_30d: 12 } };
  }
  if (clean.match(/^\/teleassistance\/ops\/guardians\/[^/]+$/)) {
    const g = demoGuardians().items[0];
    return { guardian: g, beneficiaries: [{ name: 'Christopher Ramboz', relationship: 'Fils' }] };
  }
  if (clean.match(/^\/teleassistance\/ops\/subscribers\/[^/]+$/)) {
    return { subscriber: demoSubscribers().items[0], alerts_count: 12, interventions_count: 3 };
  }
  if (clean.match(/^\/teleassistance\/ops\/interventions\/[^/]+$/)) {
    return { intervention: demoInterventions().items[0], tracking: [] };
  }
  if (clean.match(/^\/teleassistance\/ops\/recommendations\/[^/]+$/)) {
    return { recommendation: demoRecommendations().items[0] };
  }
  if (clean.startsWith('/nora/teleassist')) return { items: [], ok: true };
  if (clean.startsWith('/carewatch')) return { items: [], stats: { total: 0 } };

  return { ok: true, demo: true, path: clean };
}
